import { createTheme as createMuiV4Theme } from "@material-ui/core/styles";
import { createTheme } from "@mui/material/styles";

import { THEME_TOKENS } from "@/src/theme/themeTokens";

import type { Theme as MuiV4Theme } from "@material-ui/core/styles";
import type { Theme } from "@mui/material/styles";

import type { ResolvedTheme } from "@/src/contexts/ThemeContext";

function getPaletteOptions(resolvedTheme: ResolvedTheme) {
  const tokens = THEME_TOKENS[resolvedTheme];
  return {
    primary: { main: tokens.primary },
    error: { main: tokens.destructive },
    background: { default: tokens.background, paper: tokens.card },
    text: { primary: tokens.foreground, secondary: tokens.mutedForeground },
  };
}

export function buildMuiTheme(resolvedTheme: ResolvedTheme): Theme {
  return createTheme({
    palette: { mode: resolvedTheme, ...getPaletteOptions(resolvedTheme) },
  });
}

export function buildMuiV4Theme(resolvedTheme: ResolvedTheme): MuiV4Theme {
  return createMuiV4Theme({
    palette: { type: resolvedTheme, ...getPaletteOptions(resolvedTheme) },
  });
}
